"use client"

import { ChevronRight, type LucideIcon } from "lucide-react"
import { Link, useLocation } from "react-router"

import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible"
import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuAction,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarMenuSub,
  SidebarMenuSubButton,
  SidebarMenuSubItem,
} from "@/components/ui/sidebar"

/** Aktivní i pro detail: /invoice/123 patří pod /invoices. */
const isActivePath = (pathname: string, url: string) => {
  if (url === '/') return pathname === '/'
  if (pathname === url || pathname.startsWith(url + '/')) return true
  const singular = url.replace(/s$/, '')
  return singular !== url && (pathname === singular || pathname.startsWith(singular + '/'))
}

export function NavMain({
  items,
  title,
}: {
  items: {
    title: string
    url: string
    icon: LucideIcon
    isActive?: boolean
    /** Položka je aktivní pro všechny cesty s tímto prefixem (sekce se záložkami) */
    activePrefix?: string
    items?: {
      title: string
      url: string
    }[]
  }[]
  title?: string
}) {
  const location = useLocation()

  // const isCurrent = router.pathname === items[0].url

  if (items.length === 0) {
    return null
  }

  return (
    <SidebarGroup>
      {title && <SidebarGroupLabel className="h-7 text-[11px] font-medium uppercase tracking-[0.06em] text-muted-foreground">{title}</SidebarGroupLabel>}
      <SidebarMenu>
        {items.map((item) => (
          <Collapsible key={item.title} asChild defaultOpen={item.isActive}>
            <SidebarMenuItem>
              <SidebarMenuButton
                asChild
                tooltip={item.title}
                isActive={isActivePath(location.pathname, item.url) || (!!item.activePrefix && location.pathname.startsWith(item.activePrefix))}
                className="h-8 text-[13px] text-muted-foreground data-[active=true]:bg-sidebar-accent data-[active=true]:font-medium data-[active=true]:text-foreground data-[active=true]:[&>svg]:text-brand-strong hover:text-foreground [&>svg]:size-4"
              >
                <Link to={item.url}>
                  <item.icon />
                  <span>{item.title}</span>
                </Link>
              </SidebarMenuButton>
              {item.items?.length ? (
                <>
                  <CollapsibleTrigger asChild>
                    <SidebarMenuAction className="data-[state=open]:rotate-90" asChild>
                      <ChevronRight />
                      <span className="sr-only">Toggle</span>
                    </SidebarMenuAction>
                  </CollapsibleTrigger>
                  <CollapsibleContent>
                    <SidebarMenuSub>
                      {item.items?.map((subItem) => (
                        <SidebarMenuSubItem key={subItem.title}>
                          <SidebarMenuSubButton asChild>
                            <Link to={subItem.url}>
                              <span>{subItem.title}</span>
                            </Link>
                          </SidebarMenuSubButton>
                        </SidebarMenuSubItem>
                      ))}
                    </SidebarMenuSub>
                  </CollapsibleContent>
                </>
              ) : null}
            </SidebarMenuItem>
          </Collapsible>
        ))}
      </SidebarMenu>
    </SidebarGroup>
  )
}
